import { useState } from 'react'
import { stage } from '../../env.json'

export const useIsDemo = () => {
  const [isDemo] = useState(stage === 'demo')

  return isDemo
}
